import * as React from 'react';
import { CharacteristicGroupDataService, CharacteristicDataService } from '../../services';
import { Characteristic, CharacteristicGroup } from '../../models';
import { NavLink } from 'react-router-dom';
import { BaseRouteProps, EditState, EditProps } from '../../interfaces';
import { CharacteristicGroupForm } from './CharacteristicGroupForm';
import { UserStore, FilterStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';

interface CharacteristicGroupEditState extends EditState<CharacteristicGroup> {
    originalEntity: CharacteristicGroup | undefined;
    characteristics: Characteristic[];
    open: boolean;
}

interface CharacteristicEditProps extends BaseRouteProps<EditProps> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class CharacteristicGroupEdit extends React.Component<CharacteristicEditProps, CharacteristicGroupEditState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);

    constructor(props: CharacteristicEditProps) {
        super(props);

        this.state = {
            originalEntity: undefined,
            characteristics: [],
            open: false
        };
    }

    public componentDidMount() {
        if (this.props.match.params.id) {
            this.characteristicGroupDataService.get(this.props.match.params.id)
                .then((characteristicGroup: CharacteristicGroup) => {
                    this.setState({
                        originalEntity: characteristicGroup
                    });

                    this.characteristicDataService.getAllByGroup(characteristicGroup)
                        .then((characteristics: Characteristic[]) => {
                            this.setState({
                                characteristics: characteristics
                            });
                        });
                });
        }
    }

    @computed get isSuperAdmin() {
        return this.props.UserStore!.userRoleIn(['superAdmin']);
    }

    private delete() {
        if (this.state.originalEntity && confirm('Are you sure you want to delete this characteristic group?')) {
            this.characteristicGroupDataService.delete(this.state.originalEntity).then(() => {
                if (this.state.originalEntity) {
                    this.props.history.push('/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristicGroups');
                }
            });
        }
    }

    private ActionsButton() {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${this.state.open ? 'open' : ''}`}>
                    {this.isSuperAdmin && <li className="options-header">Maintenance</li>}
                    {this.isSuperAdmin && <li className="options-entry" onClick={(e) => this.delete()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-delete" /> <span style={{color: 'red'}}> Delete Characteristic Group</span>
                        </div>
                        <div className="options-entry-desc">
                            This will soft delete the characteristic group from the system.
                        </div>
                    </li>}

                </ul>
        </div>);
    }

    public render() {
        if (this.state.originalEntity === undefined) {
            return <div />;
        }

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-sm-10 col-md-8 col-xs-12">    
                                <div className="title">
                                    {this.state.originalEntity.secondaryReport ? <NavLink to={'/secondaryreport/' + this.state.originalEntity.secondaryReport.id}>
                                        <span className="glyphicon glyphicon-triangle-left" />
                                    </NavLink> : <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/characteristicgroups'}>
                                        <span className="glyphicon glyphicon-triangle-left" />
                                    </NavLink>}
                                    &nbsp; 
                                    Characteristic Group Edit
                                </div>
                                {this.state.originalEntity.secondaryReport && <small><i>for report '{this.state.originalEntity.secondaryReport.name}'</i></small>}
                            </div>
                            <div className="col-sm-2 col-md-4 text-right">
                                {this.isSuperAdmin && this.ActionsButton()}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <CharacteristicGroupForm defaultValues={this.state.originalEntity} surveyVersionId={this.state.originalEntity.surveyVersionID} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />                    
                    </div>
                </div>
            </div>);
    }

    private save(values: any) {
        this.characteristicGroupDataService.update(values).then((result: CharacteristicGroup) => {
            this.props.history.push('/');
            this.props.history.push('/characteristicgroup/' + result.id);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupEdit.tsx